import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  UiMoleculeDialogAdminUpsertComponent,
  AdminUpsertData,
} from '../components/molecules/ui-molecule-dialog-admin-upsert/ui-molecule-dialog-admin-upsert.component';
import { UserCreate, UserUpdate } from '@core/services/use-cases/user.service';

export interface AdminDialogResult {
  mode: 'create' | 'edit';
  payload: UserCreate | UserUpdate;
  userId?: string;
  newPassword?: string; // Para cambios de contraseña en modo edición
}

@Injectable({
  providedIn: 'root',
})
export class DialogAdminUpsertService {
  constructor(private dialog: MatDialog) {}

  open(data: AdminUpsertData, width = '500px'): Observable<AdminDialogResult | undefined> {
    const ref = this.dialog.open(UiMoleculeDialogAdminUpsertComponent, {
      width,
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: ['dialog-md', 'dialog-safe-area'],
      data,
    });
    return ref.afterClosed();
  }
}
